/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import jApiEmployee from '@/services/jApiUserEmployee';
import router from '@/router';

const state = {
  employee_created: false,
  employee_detail: null,
  organigram_detail: null,
  list_company: null,
  list_country: [],
  list_province: [],
  list_city: [],
  list_bank: [],
  list_teams: [],
  list_education_information: [],
  list_emergency_contact: [],
  list_family_relations: [],
  list_medical_records: [],
  list_employee_documents: [],
  list_career_histories: [],
  used_facilities_on_board: [],
  list_facilities_on_board: [],
  list_on_boarding: [],
  list_action: [],
  reason: [],
  list_user_historical: [],
  list_type_employee: [],
  activity_logs: [],
  list_reason: [],
  user_detail: null,
};

const getters = {
};

const mutations = {
  employeeCreated(state) {
    state.employee_created = !state.employee_created;
    router.replace('/administrator');
  },

  employeeUpdated(state) {
    state.employee_created = !state.employee_created;
    router.replace('/administrator');
  },

  showDetailEmployee(state, data) {
    state.employee_detail = data.user;
  },

  showListType(state, data) {
    state.list_type_employee = data;
  },

  showListCompany(state, data) {
    data.forEach((val) => {
      val.name = `${val.code} - ${val.name}`;
    });
    state.list_company = data;
  },

  showListCountry(state, data) {
    state.list_country = data.data;
  },

  showListProvince(state, data) {
    state.list_province = data.data;
  },

  showListCity(state, data) {
    state.list_city = data.data;
  },

  showListBank(state, data) {
    state.list_bank = data;
  },

  showDetailOrganigram(state, data) {
    state.organigram_detail = data.data ? data.data : [];
  },

  setReasonList(state, data) {
    state.list_reason = data;
  },

  showListTeams(state, data) {
    state.list_teams = data;
  },
  mutateListEducationInformation(state, data) {
    state.list_education_information = data;
  },
  showEmergencyContact(state, data) {
    state.list_emergency_contact = data;
  },
  mutateFamilyRelations(state, data) {
    state.list_family_relations = data;
  },
  mutateMedicalRecords(state, data) {
    state.list_medical_records = data;
  },
  mutateEmployeeDocuments(state, data) {
    state.list_employee_documents = data;
  },
  mutateGetUsedFacilitiesOnBoarding(state, data) {
    state.used_facilities_on_board = data.data;
  },
  mutateGetFacilitiesOnBoarding(state, data) {
    state.list_facilities_on_board = data.data;
  },
  mutateCreateFacilitiesOnBoarding(state, data) {
    state.list_on_boarding = data.data;
  },
  mutateGetListAction(state, data) {
    state.list_action = data.data;
  },
  mutateReasonUpdate(state, data) {
    state.reason = data;
  },
  mutateListUserHistorical(state, data) {
    state.list_user_historical = data.data.data;
  },
  setActivityLogs(state, data) {
    state.activity_logs = data.data;
  },

  setDetailEmployee(state, data) {
    state.user_detail = data;
  },
};

const actions = {
  async createEmployee({ dispatch, commit }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const createEmployee = await jApiEmployee.createEmployeeAuthService(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', createEmployee.message, { root: true });
      commit('employeeCreated');
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async detailEmployee({ commit, dispatch }, employeeId) {
    try {
      const detailEmployee = await jApiEmployee.detailEmployee(employeeId);
      commit('showDetailEmployee', detailEmployee);
      dispatch('detailOrganigram', { user_company_id: detailEmployee.user.user_company_id });
    } catch (err) {
      // eslint-disable-next-line
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async updateEmployee({ dispatch, commit }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const updateEmployee = await jApiEmployee.updateEmployee(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', updateEmployee.message, { root: true });
      commit('employeeUpdated');
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
    }
  },

  async updateWithReason({ dispatch }, { id, req }) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const updateWithReason = await jApiEmployee.updateWithReason(id, req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', updateWithReason.message, { root: true });
      return updateWithReason;
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      // dispatch('jStoreNotificationScreen/toggleProblem',
      //   err.response.data.errors[0].message, { root: true });
      return err.response.data;
    }
  },

  async changePasswordEmployee({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const response = await jApiEmployee.changePasswordEmployee(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', response.message, { root: true });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
    }
  },

  async deleteEmployee({ dispatch, commit }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const deleteEmployee = await jApiEmployee.deleteEmployee(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', deleteEmployee.message, { root: true });
      commit('employeeCreated');
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
    }
  },

  async getTypeEmployee({ dispatch, commit }, reqData) {
    try {
      const listEmployee = await jApiEmployee.listEmployeeType(reqData);
      const type = listEmployee.data;
      type.forEach((lab, index) => {
        type[index].label = lab.name;
      });
      commit('showListType', type);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListBank({ dispatch }, { reqData, callback }) {
    try {
      const listBank = await jApiEmployee.listBank(reqData);
      const res = listBank.data;
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListBankAll({ commit, dispatch }, reqData) {
    try {
      const listBank = await jApiEmployee.listBank(reqData);
      const res = listBank.data;
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      commit('showListBank', res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListCompany({ commit, dispatch }, req) {
    try {
      const listCompany = await jApiEmployee.listCompany(req);
      commit('showListCompany', listCompany.data);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListCountry({ commit, dispatch }) {
    try {
      const listCountry = await jApiEmployee.listCountry();
      commit('showListCountry', listCountry);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListProvince({ commit, dispatch }, req) {
    try {
      const listProvince = await jApiEmployee.listProvince(req);
      commit('showListProvince', listProvince);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListCity({ commit, dispatch }, req) {
    try {
      const listCity = await jApiEmployee.listCity(req);
      commit('showListCity', listCity);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListTeams({ commit, dispatch }, reqData) {
    try {
      const listTeams = await jApiEmployee.listTeams(reqData);
      const newVal = listTeams.data;
      newVal.forEach((lab, index) => {
        newVal[index].name = lab.title;
      });
      commit('showListTeams', newVal);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async actionGetReasonList({ commit, dispatch }) {
    try {
      const res = await jApiEmployee.getReasonList();
      const newVal = res.data;
      newVal.forEach((lab, index) => {
        newVal[index].name = lab.name;
      });
      commit('setReasonList', newVal);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListDivision({ dispatch }, { reqData, callback }) {
    try {
      const listDivision = jApiEmployee.getDivisionList(reqData);
      const res = listDivision.data.data;
      res.forEach((lab, index) => {
        res[index].label = lab.name;
      });
      callback(null, res);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.data.message, { root: true });
    }
  },

  async detailOrganigram({ commit }, employeeId) {
    try {
      const detailOrganigram = await jApiEmployee.detailOrganigram(employeeId);
      commit('showDetailOrganigram', detailOrganigram);
    } catch (err) {
      if (err.response.data.message.includes('Organigram / Position not found, please another user')) {
        commit('showDetailOrganigram', []);
      }
      // eslint-disable-next-line
      // dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListPosition({ dispatch }, { reqData, callback, label = 'name' }) {
    try {
      const listPosition = await jApiEmployee.listPosition(reqData);
      const res = [...listPosition.data];
      res.forEach((lab, index) => {
        // eslint-disable-next-line
        res[index].name = lab.name;
        // eslint-disable-next-line
        res[index].user_name = lab.user ? (lab.user.profile ? (`${lab.user.profile.first_name ? lab.user.profile.first_name : ''} ${lab.user.profile.last_name ? lab.user.profile.last_name : ''}`) : '') : '';
        // eslint-disable-next-line
        res[index].email = lab.user ? (lab.user.email ? lab.user.email : '-') : '-';
        res[index].label = lab[label];
      });
      callback(null, [...res]);
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
  },

  async getListPositionDefault({ dispatch }) {
    let res = null;
    try {
      const reqData = {
        pagination: {
          limit: 50,
          page: 1,
          column: '',
          ascending: true,
          query: '',
          query_type: 'position',
        },
      };
      const listPosition = await jApiEmployee.listPosition(reqData);
      res = listPosition.data;
      res.forEach((lab, index) => {
        res[index].name = lab.name;
        // eslint-disable-next-line
        res[index].user_name = lab.user ? (lab.user.profile ? (`${lab.user.profile.first_name ? lab.user.profile.first_name : ''} ${lab.user.profile.last_name ? lab.user.profile.last_name : ''}`) : '') : '';
        // eslint-disable-next-line
        res[index].email = lab.user ? (lab.user.email ? lab.user.email : '-') : '-';
        res[index].label = lab.name;
        res[index].is_delete = false;
        res[index].relation_id = 0;
      });
    } catch (err) {
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
    }
    return res;
  },

  async updateOrganigram({ dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please wait...', { root: true });
    try {
      const updateOrganigram = await jApiEmployee.updateOrganigram(req.payload);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', updateOrganigram.message, { root: true });
      dispatch('detailOrganigram', { user_company_id: req.user_company_id });
    } catch (err) {
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
    }
  },
  async addEducationInformation(req) {
    await jApiEmployee.addEducationInformation(req);
  },
  async getListEducationInformation({ commit }, req) {
    const data = await jApiEmployee.getListEducationInformation(req);
    commit('mutateListEducationInformation', data);
  },
  async getEmergencyContacts({ commit }, rootId) {
    const list = await jApiEmployee.getEmergencyContacts(rootId);
    commit('showEmergencyContact', list);
  },

  async createEmergencyContacts(req) {
    await jApiEmployee.createEmergencyContacts(req);
  },

  async deleteEmergencyContacts(req) {
    await jApiEmployee.deleteEmergencyContacts(req);
  },

  async getFamilyRelations({ commit }, employeeId) {
    const listFamilyRelations = await jApiEmployee.getFamilyRelations(employeeId);
    commit('mutateFamilyRelations', listFamilyRelations);
  },

  async getMedicalRecords({ commit }, employeeId) {
    const listMedicalRecords = await jApiEmployee.getMedicalRecords(employeeId);
    commit('mutateMedicalRecords', listMedicalRecords);
  },

  async getEmployeeDocuments({ commit }, employeeId) {
    const listEmployeeDocuments = await jApiEmployee.getEmployeeDocuments(employeeId);
    commit('mutateEmployeeDocuments', listEmployeeDocuments);
  },

  async getCareerHistories({ commit }, employeeId) {
    const listCareerHistories = await jApiEmployee.getCareerHistories(employeeId);
    commit('mutateEmployeeDocuments', listCareerHistories);
  },

  async getFacilitiesOnBoarding({ commit }, employeeId) {
    const getFacilitiesOnBoarding = await jApiEmployee.getFacilitiesOnBoarding(employeeId);
    commit('mutateGetFacilitiesOnBoarding', getFacilitiesOnBoarding);
  },
  async getAllFacilitiesOnBoarding({ commit }, employeeId) {
    const getFacilitiesOnBoarding = await jApiEmployee.getAllUsedFacilitiesOnboarding(employeeId);
    commit('mutateCreateFacilitiesOnBoarding', getFacilitiesOnBoarding);
  },

  async getUsedFacilitiesOnBoarding({ commit }, employeeId) {
    const getUsedFacilitiesOnBoarding = await jApiEmployee.getUsedFacilitiesOnBoarding(employeeId);
    commit('mutateGetUsedFacilitiesOnBoarding', getUsedFacilitiesOnBoarding);
  },
  async getListAction({ commit }, employeeId) {
    const listAction = await jApiEmployee.getListAction(employeeId);
    commit('mutateGetListAction', listAction);
  },
  async deleteListAssignment({ commit, dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please Wait', { root: true });
    try {
      await jApiEmployee.deleteListAssignment(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', 'Deleted', { root: true });
    } catch (err) {
      if (err.response.data.errors) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
        throw err;
      } else {
        commit('mutateError');
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      }
    }
  },
  async updateReason({ commit, dispatch }, req) {
    dispatch('jStoreNotificationScreen/showLoading', 'Please Wait', { root: true });
    try {
      const reasonUpdate = await jApiEmployee.updateReason(req);
      dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
      dispatch('jStoreNotificationScreen/toggleSuccess', 'Updated', { root: true });
      commit('mutateReasonUpdate', reasonUpdate);
    } catch (err) {
      if (err.response.data.errors) {
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.errors[0].message, { root: true });
        throw err;
      } else {
        commit('mutateError');
        dispatch('jStoreNotificationScreen/hideLoading', '', { root: true });
        dispatch('jStoreNotificationScreen/toggleProblem', err.response.data.message, { root: true });
      }
    }
  },
  mutateListUserHistorical({ commit }, message) {
    commit('mutateListUserHistorical', message);
  },

  async actionGetActivityLogs({ commit }, params) {
    try {
      const res = await jApiEmployee.getActivityLogs(params);
      commit('setActivityLogs', res.data);
    } catch (err) {
      // dispatch('jStoreNotificationScreen/toggleProblem',
      //   err.response.data.message, { root: true });
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/stores/jStoreEmployee.js